import React from 'react';
import PageLayout from '../components/PageLayout';
import Dining from '../components/Dining';
import usePageMeta from '../hooks/usePageMeta';

export default function DiningPage() {
  usePageMeta(
    'Dining — Beach Bar & Restaurant | Hotel Respiro',
    'Respiro Beach Bar and Restaurant in Baía João Évora, São Vicente, Cabo Verde. Opening Spring 2027.'
  );

  return (
    <PageLayout>
      <div data-testid="dining-page">
        <Dining />
      </div>
    </PageLayout>
  );
}
